import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  templateUrl: './send-grid-index.component.html',
  styleUrls: ['./send-grid-index.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class SendGridIndexComponent {}
